import React from "react";
import {
  BusinessPlanOptions,
  Location,
  getLocationPlans,
} from "@ecologi/shared";
import { FootprintMessage } from "../../Plan/components/FootprintMessage";
import { Wrapper } from "../../Wrapper";
import { BusinessPlanSummary } from "./BusinessPlanSummary";
import { BusinessPlanTier } from "./BusinessPlanTier";
import { Link } from "../../Link";
import styles from "../styles/BusinessPlanSelect.module.scss";

export type BusinessPlanSelectProps = {
  isUpdateSubscription: boolean;
  location: Location | null;
  selectedBusinessPlanAddons: BusinessPlanOptions;
  setSelectedBusinessPlanAddons: (newAddons: any) => void;
  onClickDisplayLocalProject: () => void;
  numLocalTrees: number;
};

export const BusinessPlanSelect = ({
  isUpdateSubscription,
  location,
  selectedBusinessPlanAddons,
  setSelectedBusinessPlanAddons,
  onClickDisplayLocalProject,
  numLocalTrees,
}: BusinessPlanSelectProps) => {
  const { businessAddonsForLocation } = getLocationPlans(location);

  return (
    <>
      <Wrapper isExtraLarge className={styles.pageWrapper}>
        <h2 className={styles.title}>
          {isUpdateSubscription ? "Update" : "Create"} your Climate Action
          Workforce
        </h2>
        <p className={styles.moreThan}>
          More than 20 employees?{" "}
          <Link href="page/schedule-a-call">Speak to our team</Link>
        </p>
        <div className={styles.planBuilder}>
          <div className={styles.tiersWrapper}>
            <div className={styles.tiersHeader}>
              Select the number of employees in each plan
            </div>
            <div className={styles.tiers}>
              {Object.keys(businessAddonsForLocation)
                .reverse()
                .map((key, index) => (
                  <BusinessPlanTier
                    key={index}
                    tierKey={key}
                    tier={businessAddonsForLocation[key]}
                    location={location}
                    isUpdateSubscription={isUpdateSubscription}
                    selectedBusinessPlanAddons={selectedBusinessPlanAddons}
                    setSelectedBusinessPlanAddons={
                      setSelectedBusinessPlanAddons
                    }
                  />
                ))}
            </div>
          </div>
          <BusinessPlanSummary
            location={location}
            selectedBusinessPlanAddons={selectedBusinessPlanAddons}
            onClickDisplayLocalProject={onClickDisplayLocalProject}
            numLocalTrees={numLocalTrees}
          />
        </div>
        <div className={styles.footprintEquivalent}>
          <FootprintMessage location={location} />
        </div>
      </Wrapper>
    </>
  );
};
